export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14786.5c016400.jpg";